import {makeStyles} from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import React from "react";
import {Typography} from "@material-ui/core";
import UserAvatar from "../../../user-avatar/UserAvatar";
import {useTranslation} from "react-i18next";
import {ContactStatus} from "./ContactStatus";
import Button from "@material-ui/core/Button";

export const useStyles = makeStyles(theme => ({
    root: {
        height: 'auto',
        flexGrow: 1,
        maxWidth: 700,
    },
    search: {
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        },
        [theme.breakpoints.up('md')]: {
            width: '40%'
        }
    },
    statusColumn: {
        maxWidth: 200,
        width: 200
    },
    actionColumn: {
        maxWidth: 125,
        width: 125
    },
    avatarColumn: {
        maxWidth: 70,
        width: 70
    },
    spinner: {
        position: 'absolute',
        left: '50%'
    }
}));

export const MachineContactDataRow = ({
                                          firstName,
                                          lastName,
                                          email,
                                          userId,
                                          status,
                                          onRemoveContact,
                                      }: {
    userId: string,
    firstName: string,
    lastName: string,
    email: string,
    status: number,
    onRemoveContact: (userId: string) => (void | Promise<void>)
}) => {
    const {t} = useTranslation();
    const classes = useStyles();
    const fullName = `${firstName} ${lastName}`;
    return (
        <TableRow>
            <TableCell component="th" scope="row" className={classes.avatarColumn}>
                <UserAvatar userId={userId}/>
            </TableCell>
            <TableCell>
                <Typography variant="body1">{fullName}</Typography>
                <Typography variant="body2"
                            color={'textPrimary'}>{email}</Typography>
            </TableCell>
            <TableCell className={classes.statusColumn}>
                <ContactStatus status={status}></ContactStatus>
            </TableCell>
            <TableCell className={classes.actionColumn}>
                <Button color="primary" size="small"
                        onClick={() => onRemoveContact(userId)}>
                    {t('Machine.Contacts.Remove.Title')}
                </Button>
            </TableCell>
        </TableRow>
    )
};
